import React from "react";
import ReactDOM from "react-dom";
import "./fonts/GT-America/GT-America-Standard-Regular.otf";
import "./fonts/GT-America/GT-America-Standard-Medium.otf";
import "./fonts/GT-America/GT-America-Standard-Bold.otf";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {Routes, Route} from "react-router-dom";
import {BrowserRouter as Router} from "react-router-dom";
import {LoginCallback} from "@okta/okta-react";
import AuthGuard from "./guards/AuthGuard";
import OktaProvider from "./providers/OktaProvider";
import Logout from "./Logout";
import IndexLandingPage from "./pages/IndexLanding";
import Dealerships from "./pages/dealerships";
import KSA from "./pages/ksa";
import FeeAuditReporting from "./pages/FeeAuditReporting";
import TransactionItemHistory from "./pages/TransactionItemHistory";
import TransactionItemAdjustment from "./pages/TransactionItemAdjustment";
import SpecialPlateFees from "./pages/specialPlateFees";
import Metadata from "./pages/metadata";
import FeeAdmin from "./pages/fee-admin";
import TransactionReporting from "./pages/TransactionReporting";
import DocusignTemplates from "./pages/docusign-templates";
import TemplateConditionLine from "./pages/TemplateConditionLine";
import DocusignTemplatesReporting from "./pages/DocusignTemplatesReporting";
import TemplateConditionLinesReporting from "./pages/TemplateConditionLinesReporting";
import RegistrationStatusReporting from "./pages/RegistrationStatusReporting";
import DocumentFooterNotes from "./pages/document-footer-notes";

ReactDOM.render(
    <React.StrictMode>
        <OktaProvider>
            <Router>
                <Routes>
                    <Route element={<AuthGuard/>}>
                        <Route
                            path="/"
                            element={<IndexLandingPage page={"main"}/>}
                        />
                        <Route path="/invoicenumbers/*" element={<KSA/>}/>
                        <Route
                            path="/vehiclesalesfees/:country/*"
                            element={<FeeAdmin/>}
                        />
                        <Route
                            path="/dealerships/*"
                            element={<Dealerships/>}
                        />
                        <Route
                            path="/metadata/:country/:collection/*"
                            element={<Metadata/>}
                        />
                        <Route
                            path="/special-plate-fees/*"
                            element={<SpecialPlateFees/>}
                        />
                        <Route
                            path="/reporting/"
                            element={<IndexLandingPage page={"reporting"}/>}
                        />
                        <Route
                            path="/reporting/fee-audit-reporting/*"
                            element={<FeeAuditReporting/>}
                        />
                        <Route
                            path="/reporting/transaction-item-history/*"
                            element={<TransactionItemHistory/>}
                        />
                        <Route
                            path="/reporting/transaction-item-adjustment/*"
                            element={<TransactionItemAdjustment/>}
                        />
                        <Route
                            path="/reporting/transaction-reporting/*"
                            element={<TransactionReporting/>}
                        />
                        <Route
                            path="/reporting/docusign-templates"
                            element={<DocusignTemplatesReporting/>}
                        />
                        <Route
                            path="/reporting/templates-condition-lines"
                            element={<TemplateConditionLinesReporting/>}
                        />
                        <Route
                            path="/templates-management"
                            element={<IndexLandingPage page={"templates"}/>}
                        />
                        <Route
                            path="/templates-management/docusign-templates/:country/*"
                            element={<DocusignTemplates/>}
                        />
                        <Route
                            path="/document-footer-notes/:country/*"
                            element={<DocumentFooterNotes/>}
                        />
                        <Route
                            path="/templates-management/template-condition-lines/:country/*"
                            element={<TemplateConditionLine/>}
                        />
                        <Route
                            path="/reporting/registration-status-reporting/*"
                            element={<RegistrationStatusReporting/>}
                        />
                    </Route>
                    <Route
                        path={"/login/callback"}
                        element={<LoginCallback></LoginCallback>}
                    />
                    <Route path={"/logout"} element={<Logout/>}/>
                </Routes>
            </Router>
        </OktaProvider>
    </React.StrictMode>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
